import { useParams } from 'react-router-dom';
import TeamMembersTable from '../components/team/TeamMembersTable';
import { useSetBreadcrumbEffect } from '../contexts/BreadcrumbContext';
import { TeamQuery, TeamRemainingPaidSeatsQuery } from '../queries';
import { getFirstQueryResult } from '../utils/graphql';
import { useQueryWithMsg } from '../utils/hooks';

const TeamMembersView = ({ includeTeamInBreadcrumbs = false }) => {
  const { teamId } = useParams();

  const { msg, data } = useQueryWithMsg(TeamQuery, {
    variables: { id: teamId },
  });

  const teamData = getFirstQueryResult(data);
  useSetBreadcrumbEffect(
    [
      {
        display: `${
          includeTeamInBreadcrumbs ? teamData?.name : ''
        } Team Members`,
      },
    ],
    [includeTeamInBreadcrumbs, teamData],
  );
  const { canUpdateMembers, canUpdateSettings } =
    teamData?.allowedActions || {};

  const fetchTeamQueries = [
    {
      query: TeamQuery,
      variables: { id: teamId },
    },
    {
      query: TeamRemainingPaidSeatsQuery,
      variables: { id: teamId },
      skip: !canUpdateMembers,
    },
  ];

  return (
    <TeamMembersTable
      data={data}
      msg={msg}
      refetchQueries={fetchTeamQueries}
      readonly={!canUpdateMembers}
      showSettingsLink={canUpdateSettings}
    />
  );
};

export default TeamMembersView;
